// USD → INR display conversion. Backend stores USD floats; UI shows realistic INR.
export const USD_TO_INR = 80;

export const inr = (usd) => {
  const value = Math.round((usd || 0) * USD_TO_INR);
  return `₹${value.toLocaleString("en-IN")}`;
};

// For amounts that are already in INR (e.g. wallet balance stored in INR),
// just format with the rupee symbol.
export const inrRaw = (n) => `₹${Math.round(n || 0).toLocaleString("en-IN")}`;
